module.exports = __webpack_public_path__ + "img/certificate2.png?9d7d06a79fdaec3025b38e321e503eac";